module.exports = __webpack_public_path__ + "static/media/inconvergent-2.3c53bc83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/presentation/inconvergent-2.jpg
// module id = 330
// module chunks = 11